import { markRaw } from 'vue';
import { OnboardingFlow } from '@/types/onboarding.types';
import RiskAnalysisLaunchContent from '@/shared/components/onboarding/risk-analysis/RiskAnalysisLaunchContent.vue';

export const RiskAnalysisOnboardingFlow: OnboardingFlow = {
  key: 'risk-analysis-route',
  steps: [
    {
      title: 'Overall Risk at a Glance',
      description:
        'See the customer’s overall risk rating and a short explanation of what factors led to it.',
      index: 1,
      targets: ['[data-testid="customer-risk-analysis-summary"]'],
    },
    {
      title: 'Spot Risk Across Documents',
      description:
        'Quickly assess how risky a customer’s documents are with a visual breakdown of high, medium, and low-risk files.',
      index: 2,
      targets: ['[data-testid="customer-risk-analysis-documents"]'],
    },
    {
      title: "See What's Driving the Risk",
      description:
        'Explore all customer-level insights, grouped by risk, to understand cross-document patterns and supporting evidence.',
      index: 3,
      targets: [
        '[data-testid="customer-risk-analysis-insights"] .expandable-item:first-child',
        '[data-testid="customer-risk-analysis-insights"] .header',
      ],
    },
    {
      title: 'Review Documents by Risk Level',
      description:
        'Find and review documents organized from high to low risk, so you can focus on what matters most.',
      index: 4,
      targets: [
        '[data-testid="customer-risk-analysis-documents-full-list"] .expandable-item:first-child',
        '[data-testid="customer-risk-analysis-documents-full-list"] .header',
      ],
    },
  ],
  activationRoutes: ['customer-risk-analysis'],
  launchScreenProps: {
    imageUrl: 'images/onboarding/risk-analysis/launch_screen.webp',
    title: 'Risk Analysis, Reimagined',
    contentComponent: markRaw(RiskAnalysisLaunchContent),
  },
  intercomArticles: {
    title: 'Risk Analysis Resources',
    // note: once we will integrate with Intercom API this list will be dynamic
    articles: [
      {
        title: 'Risk Analysis Page Overview',
        description:
          'This article walks you through the insights you’ll see on a customer’s Risk Analysis page',
        link: 'https://help.inscribe.ai/en/articles/12500662-risk-analysis-page-overview',
        imageUrl: 'images/onboarding/risk-analysis/intercom_article_01_2x.webp',
      },
      {
        title: 'Understanding Document Fraud Signals',
        description: "Dive deeper into Inscribe's fraud signals",
        link: 'https://help.inscribe.ai/en/articles/7852994-understanding-document-fraud-signals',
        imageUrl: 'images/onboarding/risk-analysis/intercom_article_02_2x.webp',
      },
    ],
  },
};
